// Mock data for Nature Cévennes website

export const activities = [
  {
    id: 'vtt',
    name: 'VTT & VTT Électrique',
    slug: 'vtt',
    description: 'Parcourez le Mont Aigoual et les Grands Causses en VTT, de la balade familiale à la descente sportive.',
    imageUrl: '/vtt.jpg',
    category: 'Terrestre',
    tarif: 123.00,
    lieu : 'Meyrueis'
    
  },
  {
    id: 'trottinette',
    name: 'Trottinette Tout Terrain',
    slug: 'trottinette-tout-terrain',
    description: 'Activité ludique et accessible à tous pour découvrir les paysages cévenols autrement.',
    imageUrl: '/trottinette_montagne.jpg',
    category: 'Terrestre',
    tarif: 123.00,
    lieu : 'Meyrueis'
  },
  {
    id: 'via-ferrata',
    name: 'Via Ferrata',
    slug: 'via-ferrata',
    description: 'Parcours aménagés dans les Gorges de la Jonte pour des sensations verticales accessibles à tous.',
    imageUrl: '/via.jpg',
    category: 'Terrestre',
    tarif: 123.00,
    lieu : 'Meyrueis'
  },
  {
    id: 'canyoning',
    name: 'Canyoning',
    slug: 'canyoning',
    description: 'Les Gorges de la Dourbie et du Tapoul offrent des parcours adaptés à tous les niveaux pour découvrir le canyoning en famille ou entre amis.',
    imageUrl: '/canyoning.jpg',
    category: 'Aquatique',
    tarif: 123.00,
    lieu : 'Meyrueis'
  },
  {
    id: 'speleologie',
    name: 'Spéléologie',
    slug: 'speleologie',
    description: 'Explorez les grottes des Grands Causses, un terrain de jeu exceptionnel pour la spéléologie.',
    imageUrl: '/speleologie.jpg',
    category: 'Terrestre',
    tarif: 123.00,
    lieu : 'Meyrueis'
  },
  {
    id: 'canoe-kayak',
    name: 'Canoë-Kayak',
    slug: 'canoe-kayak',
    description: 'Descendez les Gorges du Tarn en canoë ou kayak, une activité familiale au fil de l\'eau.',
    imageUrl: '/canoe.jpg',
    category: 'Aquatique',
    tarif: 123.00,
    lieu : 'Massegros'
  },
  
  {
    id: 'randonnee',
    name: 'Randonnée Pédestre',
    slug: 'randonnee-pedestre',
    description: 'Découvrez 19 boucles de randonnées autour de Meyrueis sur les GR 6, 6A, 6B, 66 et 62A.',
    imageUrl: '/randonnee_gite.jpg',
    category: 'Terrestre',
    tarif: 123.00,
    lieu : 'Meyrueis'
  },
  {
    id: 'rafting',
    name: 'Rafting & Hot Dog',
    slug: 'rafting',
    description: 'Sensations fortes garanties dans les Gorges de la Dourbie au printemps et en automne.',
    imageUrl: '/rafting.jpg',
    category: 'Aquatique',
    tarif: 123.00,
    lieu : 'Meyrueis'
  }
];

export const sejours = [
  {
    id: 'sejour-famille',
    name: 'Séjour Famille',
    details: 'Accompagnateur en Montagne depuis plus de 30 ans, Michaël vous transmettra la passion de sa terre natale. Grâce à son expertise technique et sa connaissance parfaite du terrain, il adapte chaque itinéraire au quotidien pour correspondre précisément au niveau de votre groupe.',
    url :'/contact?category=draille&stay=famille',
    description: 'En famille, vous profiterez et découvrirez cet environnement au travers d\'activités de pleine nature.',
    imageUrl: '/canoe.jpg',
    targetAudience: 'Familles (+ 10 ans)',
    duration: '5 jours',
    price: 499.00,
    activities: [
      'Randonnée sur les corniches du Causse Méjan',
      'Descente du Mont Aigoual en trottinette tout terrain',
      'Canoë Kayak sur les Gorges du Tarn',
      'Via-Ferrata',
      'Canyoning'
    ]
  },
  {
    id: 'sejour-randonnee',
    name: 'Séjour Randonnée',
    details: 'Accompagnateur en Montagne depuis plus de 30 ans, Michaël vous transmettra la passion de sa terre natale. Grâce à son expertise technique et sa connaissance parfaite du terrain, il adapte chaque itinéraire au quotidien pour correspondre précisément au niveau de votre groupe.',
    url :'/contact?category=draille&stay=rando',
    description: 'Découverte de différents paysages au cœur du Parc National des Cévennes, patrimoine mondial de l\'Unesco.',
    imageUrl: '/randonnee_gite.jpg',
    targetAudience: 'Randonneurs',
    duration: '4 jours',
    price: 407.50,
    activities: [
      'Jour 1 : Couronnes du Causse Méjean (13 à 16 kms)',
      'Jour 2 : Mont Aigoual (12 à 16 kms)',
      'Jour 3 : Corniches de La Dourbie et site de Roques Altes (12 à 16 kms)',
      'Jour 4 : Corniches de Jonte et Tarn (15 kms)'
    ]
  },
  {
    id: 'sejour-vtt',
    name: 'Séjours VTT',
    details: 'Accompagnateur en Montagne depuis plus de 30 ans, Michaël vous transmettra la passion de sa terre natale. Grâce à son expertise technique et sa connaissance parfaite du terrain, il adapte chaque itinéraire au quotidien pour correspondre précisément au niveau de votre groupe.',
    url :'/contact?category=draille&stay=vtt',
    description: 'Plaisir et Découverte sont les maîtres mots de ce séjour, sillonnez le Causse Méjean, le Causse Noir, et le Massif de l’Aigoual en VTT. ',
    imageUrl: '/vtt.jpg',
    targetAudience: 'Cycliste / Sportifs',
    duration: '4 jours d\'accompagnement',
    price: 376.00,
    activities: [
      'Parcours de niveau technique moyen',
      'Distances de 30 à 45 kms par jour', 
      'Accessibles en VTT musculaire ou VTAE selon la condition physique.'
    ]
  }
];
export const hebergements = {
  draille: {
    name: 'Gîte La Draille',
    slug: 'gite-la-draille',
    type: 'Gîte d\'étape et de séjour',
    classification: '3 épis Gîtes de France',
    location: '465 route de Florac, 48150 Meyrueis',
    phone: '04 66 45 65 37',
    mobile: '06 19 43 50 39',
    description: 'Idéalement situé à la croisée des grands itinéraires de randonnée, le Gîte La Draille constitue le point de départ privilégié pour vos étapes du Tour du Mont Aigoual, la traversée du Causse Méjean ou le Chemin de Saint-Guilhem. Que vous soyez cavalier, randonneur pédestre ou adepte de sports de plein air, c’est le lieu de séjour parfait pour profiter pleinement des activités de pleine nature au sein des Gorges du Tarn et du Parc National des Cévennes.',
    capacity: 'Jusqu\'à 28 personnes',
    services: [
      '6 Chambres avec sanitaires privatifs',
      'Parking privé',
      'Restauration / Pique-nique',
      'Bar',
      'Espace repos / détente',
      'Piscine chauffée / terrasse détente',
      'Garage sécurisé',
      'Location Vélo'
    ],
    images: [
      '/piscine.jpg',
      '/gite.jpg'
    ],
    tarifs: [,
      ''
    ]
  },
  pegue: {
    name: 'Camping La Pègue',
    slug: 'camping-la-pegue',
    type: 'Camping et base de loisirs',
    classification: 'Agréé DDJSCS',
    location: 'Gorges de la Jonte, 48150 Meyrueis',
    phone: '06 81 61 63 50',
    description: 'Camping base de loisirs au cœur du Parc National des Cévennes, agréé pour l\'accueil de groupes de jeunes de 6 à 17 ans.',
    capacity: 'Groupes jusqu\'à 50 personnes',
    services: [
      'Emplacements camping',
      'Marabouts en location',
      'Hébergement en dur (Le Rocher)',
      'Restauration sur demande',
      'Base de loisirs complète',
      'Ateliers cirque, danse, environnement'
    ],
    images: [
      '/camping.jpg',
      '/city.jpg'
    ]
  }
};

export const about = {
  histoire: 'Nature Cévennes est une structure familiale implantée à Meyrueis depuis plus de 20 ans, spécialisée dans l\'accueil de groupes et l\'organisation d\'activités de pleine nature.',
  valeurs: [
    'Respect de l\'environnement',
    'Découverte du territoire',
    'Sécurité et professionnalisme',
    'Accueil chaleureux et personnalisé'
  ],
  agréments: [
    'Agréé Jeunesse et Sport (DDJSCS)',
    'Gîtes de France 3 épis',
    'Relais Motard',
    'Accueil Cyclotourisme',
    'Chèques vacances acceptés'
  ],
  territoire: {
    description: 'Meyrueis est situé au sud de la Lozère, au confluent de trois vallées, au pied du Mont Aigoual (1567m) et au cœur du Parc National des Cévennes.',
    sitesProches: [
      'Gorges du Tarn',
      'Gorges de la Jonte',
      'Gorges de la Dourbie',
      'Mont Aigoual',
      'Grands Causses',
      'Grotte de Dargilan',
      'Aven Armand',
      'Abîme de Bramabiau',
      'Viaduc de Millau'
    ]
  }
};

export const googleReviews = {
  averageRating: 4.8,
  totalReviews: 127,
  googlePlaceUrl: 'https://maps.app.goo.gl/PStVgsPzZCNCafZXA', // À remplacer par votre vraie URL
  reviews: [
    {
      id: 1,
      author: 'Prevaure',
      rating: 5,
      date: 'Juil. 2024',
      text: 'Gîte absolument parfait ! Tout était parfait ! L’accueil très sympathique, Hôtes arrangeants et agréables.',
      avatar: 'P',
      platform: 'tripadvisor'
    },
    {
      id: 2,
      author: 'Isabelle Z',
      rating: 5,
      date: 'Mai 2024',
      text: 'Gîte très sympa et très propre. Les chambres sont spacieuses munies de douches wc et lavabo. Très bon rapport qualité prix',
      avatar: 'IZ',
      platform: 'tripadvisor'
    },
    {
      id: 3,
      author: 'Denis G',
      rating: 5,
      date: 'Sept. 2023',
      text: 'Un accueil chaleureux. Gite très bien,entretenu la chambre etait parfaite. Le repas comme le petit déjeuner sont délicieux.',
      avatar: 'DG',
      platform: 'tripadvisor'
    },
    {
      id: 4,
      author: 'Julie M',
      rating: 5,
      date: 'Juil. 2025',
      text: 'Fremyc, nous avons eu la chance de louer des VTT ici des paysages incroyables, un super randonnée à vélo je recommande 👍🏼',
      avatar: 'JM',
      platform: 'google'
    },
    {
      id: 5,
      author: 'Danielle V.',
      rating: 5,
      date: 'Juil. 2025',
      text: 'Fremyc, descente en trottinette tout terrain ! L\'accompagnateur s\'est transformé en guide local. La personne de l\'accueil est super.',
      avatar: 'DV',
      platform: 'google'
    },
    {
      id: 6,
      author: 'Hocine S.',
      rating: 5,
      date: 'Août 2025',
      text: 'Camping La Pègue, Agréable pour les groupes',
      avatar: 'HS',
      platform: 'google'
    }
  ]
};

export const tripadvisorReviews = {
  averageRating: 4.8,
  totalReviews: 11,
  tripadvisorUrl: 'https://www.tripadvisor.fr/Hotel_Review-g672975-d14183635-Reviews-La_Draille-Meyrueis_Lozere_Occitanie.html?m=19905', // À remplacer par votre vraie URL
};

export const contact = {
  email: 'contact@nature-cevennes.com',
  phones: {
    draille: {
      fixe: '04 66 45 65 37',
      mobile: '06 19 43 50 39'
    },
    fremyc: {
      mobile1: '06 58 13 48 48',
      mobile2: '06 81 61 63 50'
    },
    pegue: {
      mobile: '06 81 61 63 50'
    }
  },
  adresses: {
    draille: '465 route de Florac, 48150 Meyrueis',
    fremyc: 'Place Sully, 48150 Meyrueis',
    pegue: 'Gorges de la Jonte, 48150 Meyrueis'
  },
  mapCenter: {
    lat: 44.1775,
    lng: 3.4325
  }
};